import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DataSourceCustomAction } from '@m4u-angular/base/datalayer/BaseDataSources';
import { DataLoadOptions } from '@m4u-angular/base/datalayer/DataLoadOptions';
import { PushMessageEndpoint } from '@m4u-angular/core/endpoints/push-message.endpoint';
import { SidebarService } from '@m4u-angular/core/framework/sidebar.service';
import { EnumSidebarStates } from '@m4u-angular/core/framework/sysenums.enum';
import { Subscription } from 'rxjs';
import { BaseComponent } from '../../../base/component/BaseComponent';
import { ServiceBagService, ServiceBagServices } from '../../../base/component/ServiceBag';
import { BaseState, PushMessageListParams } from '../../../base/entities/BaseEntities';

class State extends BaseState {
    IsLoadAllNotifications: boolean;
}

@Component({
    providers: ServiceBagServices,
    selector: 'app-push-message-list',
    templateUrl: './push-message-list.component.html',
    styleUrls: ['./push-message-list.component.scss']
})
export class PushMessageListComponent extends BaseComponent<State> {

    @Output() OnAllNotificationsLoad = new EventEmitter<boolean>();

    constructor(A: ServiceBagService,
        private pushMessageEndpoint: PushMessageEndpoint,
        private sidebarService: SidebarService) {
        super(A, 'PushMessageListComponent', State);
    }

    private _sidebarStateSubscription: Subscription;

    protected override OnInitComponent(): void {
        this.LoadPushMessages();

        this._sidebarStateSubscription = this.sidebarService.SidebarState.subscribe((state) => {
            if (state.SidebarName === 'Notifications' && state.State === EnumSidebarStates.Opened && this.DS('PushMessages')) {
                this.DS('PushMessages').Reload();
            }
        });
    }

    protected override OnDestroyComponent(): void {
        this._sidebarStateSubscription && this._sidebarStateSubscription.unsubscribe();
    }

    LoadPushMessages() {
        const params = new PushMessageListParams;
        params.IsLoadAllNotifications = this.State.IsLoadAllNotifications;

        this.DataSources['PushMessages'] = new DataSourceCustomAction((options: DataLoadOptions) =>
            this.pushMessageEndpoint.GetPushMessages(params, options), undefined, undefined, false);
    }

    OnLoadAllNotifications() {
        this.State.IsLoadAllNotifications = true;
        this.LoadPushMessages();
        this.OnAllNotificationsLoad.emit(this.State.IsLoadAllNotifications);
    }

    GetNoDataText() {
        return !this.State.IsLoadAllNotifications ? this.RC('lblNoUnreadMessages') : this.RC('genNoData');
    }

    OnNotificationRead() {
        this.DS('PushMessages').Reload();
    }
}
